<template>
  <el-dialog v-dialog-drag :title="title" :width="width" :visible="visible" :close-on-click-modal="false" @close="handleClose">
    <el-form ref="editForm" :model="data" label-width="100px">
      <el-form-item label="客户" prop="Name">
        <el-input v-model.trim="data.Name" :disabled="!isNew" placeholder="请输入客户名称" />
      </el-form-item>
      <el-form-item label="昵称" prop="Nick">
        <el-input v-model.trim="data.Nick" placeholder="请输入客户昵称" />
      </el-form-item>
      <el-form-item label="QQ" prop="QQ">
        <el-input v-model="data.QQ" placeholder="请输入QQ" />
      </el-form-item>
      <el-form-item label="等级" prop="Levels">
        <el-select v-model="selectedLevel" placeholder="请选择等级" :loading="loadingLevels" clearable style="width: 100%">
          <el-option v-for="level in levelOptions" :key="level.value" :label="level.label" :value="level.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="发货仓库" v-if="$store.state.routes.systemSetting.MultiWarehouse" prop="WID">
        <warehouse-select :value.sync="data.WID"></warehouse-select>
      </el-form-item>
      <el-form-item label="小票显示" prop="AmountType" class="amount-type">
        <el-select v-model="data.Config.PriceType" placeholder="单价" clearable>
          <el-option
            v-for="(option, index) in showPriceOptions"
            :key="'price-type-' + index"
            :label="option.label"
            :value="option.value"
          ></el-option>
        </el-select>
        <el-select v-model="data.Config.SubtotalType" placeholder="小计" clearable>
          <el-option
            v-for="(option, index) in showPriceOptions"
            :key="'sub-total-type-' + index"
            :label="option.label"
            :value="option.value"
          ></el-option>
        </el-select>
        <el-select v-model="data.Config.TotalAmountType" placeholder="总金额" clearable>
          <el-option
            v-for="(option, index) in showPriceOptions"
            :key="'tatol-amount-type-' + index"
            :label="option.label"
            :value="option.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">关闭</el-button>
      <el-button type="primary" size="small" :loading="loading" @click="handleSave">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { submit } from '@/api/base'
import WarehouseSelect from '@/views/components/common/WarehouseSelect.vue'
export default {
  name: 'CustomerEdit',
  components: {
    WarehouseSelect,
  },
  data() {
    return {
      loading: false,
      visible: false,
      width: '470px',
      title: '新增',
      isNew: true,
      data: {
        Name: '',
        QQ: '',
        Nick: '',
        WID: undefined,
        Config: {
          PriceType: null,
          SubtotalType: null,
          TotalAmountType: null,
        },
      },
      showPriceOptions: [
        {
          label: '商品价',
          value: 'price',
        },
        {
          label: '客户价',
          value: 'settlePrice',
        },
        {
          label: '不显示',
          value: 'none',
        },
      ],
      levelOptions: [], // 等级选项
      selectedLevel: null, // 选中的等级
      loadingLevels: false, // 等级加载状态
    }
  },
  methods: {
    async init(title, row) {
      this.visible = true
      this.title = title

      if (!row) {
        this.isNew = true
        this.handleClear()
      } else {
        this.isNew = false
        this.data = { ...row }
        this.selectedLevel = row.LevelCode
      }
      // 加载等级选项
      await this.loadLevelOptions()
    },
    async loadLevelOptions() {
      this.loadingLevels = true
      try {
        const res = await submit('/api/common/getCustomerParameter?key=PurchaserLevels')
        if (res.success && res.data) {
          const levelsData = JSON.parse(res.data)
          this.levelOptions = Object.keys(levelsData).map(key => ({
            value: key,
            label: levelsData[key] || key,
          }))
          if (!this.isNew && this.data.Levels) {
            const levels = JSON.parse(this.data.Levels)
            this.selectedLevel = levels.length > 0 ? levels[0] : null // 使用null表示空值
          }
        }
      } catch (error) {
        console.error('加载等级失败:', error)
      } finally {
        this.loadingLevels = false
      }
    },
    async handleSave() {
      const _this = this
      if (_this.data.Name == '') {
        _this.$message({ type: 'error', message: '客户名称不能为空' })
        return false
      }
      //选择等级
      _this.data.Levels = _this.selectedLevel ? JSON.stringify([_this.selectedLevel]) : '[]'
      _this.data.LevelCode = _this.selectedLevel || ''
      _this.data.LevelName = _this.selectedLevel ? _this.levelOptions.find(opt => opt.value === _this.selectedLevel)?.label || '' : ''
      const param = {
        ChangeType: 'info',
        Purchaser: JSON.parse(JSON.stringify(_this.data)),
      }
      let result
      _this.loading = true
      if (_this.isNew) {
        param.Purchaser.PurchaserName = param.Purchaser.Name
        param.Purchaser.PurchaseQQ = param.Purchaser.QQ
        delete param.Purchaser.Name
        delete param.Purchaser.QQ
        result = await submit('/api/stall/AddPurchaser', param.Purchaser).finally(() => {
          _this.loading = false
        })
      } else {
        result = await submit('/api/stall/savePurchaser', param).finally(() => {
          _this.loading = false
        })
      }
      _this.handleClose()
      _this.$message({ type: 'success', message: '保存成功' })
      _this.$emit('handleQuery')
    },
    handleClear() {
      this.data = {
        Name: '',
        QQ: '',
        WID: undefined,
        Config: {
          PriceType: null,
          SubtotalType: null,
          TotalAmountType: null,
        },
        Levels: '[]',
      }
      this.selectedLevel = null
    },
    handleClose() {
      this.visible = false
      this.handleClear()
    },
  },
}
</script>

<style lang="scss" scoped>
.amount-type {
  ::v-deep {
    .el-select {
      width: 105px !important;

      &:not(:last-child) {
        margin-right: 2px;
      }
    }
  }
}
</style>
